module.exports = __webpack_public_path__ + "assets/flat-tire.3cbdeca9.svg";